/* @jsx h */
import { useRef, useState, useEffect } from 'preact/hooks';

const FilterZip = ({ facet, triggerAjaxSubmit, pluginNamespace, isReset }) => {
  const [zipInput, setZipInput] = useState('');
  const zipInputEl = useRef(null);
  const id = {
    zip: 'search-zip',
    zipStore: 'search-zip-store',
    selfLocate: 'self-locate',
    latLong: 'search-latlong',
    locationAlert: 'self-locate-alert',
  };
  const domNode = {
    zip: null,
    zipStore: null,
    selfLocate: null,
    latLong: null,
    locationAlert: null,
  };

  function handleChange(e) {
    if (e.target.value.length > 2) {
      setZipInput(`${facet.name}:${e.target.value}`);
    } else {
      setZipInput('');
    }
  }

  function updateLatLng(position) {
    domNode.latLong.value =
      position.coords.latitude + ',' + position.coords.longitude;

    domNode.locationAlert.textContent = '';
    domNode.selfLocate.classList.remove('input__strike-label');

    togglePlz(true);
  }

  function clearLatLng(err) {
    if (err && err.message) {
      domNode.locationAlert.textContent = 'Nicht verfügbar!';
      domNode.selfLocate.classList.add('input__strike-label');
    } else {
      domNode.locationAlert.textContent = '';
      domNode.selfLocate.classList.remove('input__strike-label');
    }

    domNode.latLong.value = '';
    domNode.selfLocate.checked = false;

    togglePlz(false);
  }

  function togglePlz(disable) {
    domNode.zipStore.disabled = disable;
    domNode.zip.disabled = disable;

    if (disable) {
      domNode.zip.setAttribute('style', 'opacity:0.7');
    } else {
      domNode.zip.removeAttribute('style');
    }
  }

  function handleChangeLocate(e) {
    checkAssignNodes();

    if (e.target.checked) {
      navigator.geolocation.getCurrentPosition(updateLatLng, clearLatLng);
    } else {
      clearLatLng();
    }
  }

  function checkAssignNodes() {
    if (!domNode.zip) {
      domNode.zip = document.getElementById(id.zip);
      domNode.zipStore = document.getElementById(id.zipStore);
      domNode.selfLocate = document.getElementById(id.selfLocate);
      domNode.latLong = document.getElementById(id.latLong);
      domNode.locationAlert = document.getElementById(id.locationAlert);
    }
  }

  function generalReset() {
    checkAssignNodes();

    domNode.selfLocate.checked = false;
    domNode.latLong.value = '';
    togglePlz(false);
  }

  useEffect(() => {
    setZipInput('');
    generalReset();
  }, [isReset]);

  return (
    <div className="filter__list">
      <input
        className="is-hidden"
        value={zipInput}
        ref={zipInputEl}
        id={id.zipStore}
        name={zipInput && !isReset ? `${pluginNamespace}[filter][]` : ''}
      />
      <div className="filter__item filter__item--flex">
        <label htmlFor="zip-code" className="filter__label">
          PLZ
        </label>
        <input
          id={id.zip}
          type="text"
          className="input--small filter__zip"
          minLength="5"
          maxLength="5"
          onChange={handleChange}
        />
      </div>

      <div className="filter__item filter__item--flex" hidden>
        <div className="input--checkbox">
          <input
            id={id.selfLocate}
            type="checkbox"
            className="filter__self-locate"
            onChange={handleChangeLocate}
          />
          <label
            htmlFor={id.selfLocate}
            className="filter__label filter__label--checkbox"
          >
            <span className="input__label-text">Meinen Standort verwenden</span>
            <div>
              <strong id={id.locationAlert} />
            </div>
          </label>
          <span className="input__checkbox-mark" aria-hidden="true" />
        </div>
        <input type="hidden" name="tx_solr[pt]" id={id.latLong} />
      </div>

      <div className="filter__item filter__item--flex">
        <label htmlFor="search-distance" class="filter__label">
          Umkreis
        </label>
        <select
          id="search-distance"
          className="input--small input--auto"
          name={`${pluginNamespace}[d]`}
        >
          <option value="">-</option>
          <option value="10">10 km</option>
          <option value="20">20 km</option>
          <option value="50">50 km</option>
          <option value="100">100 km</option>
        </select>
      </div>
    </div>
  );
};

export default FilterZip;
